import { render, staticRenderFns } from "./giftcard-thumb.vue?vue&type=template&id=dffa27de"
import script from "./giftcard-thumb.vue?vue&type=script&lang=js"
export * from "./giftcard-thumb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports